import { Button, Typography } from "@material-ui/core"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { ErrorBoundary } from "react-error-boundary"
import Box from "../components/Common/Box"

function ErrorFallback({ error, resetErrorBoundary }) {
  console.error(error)

  return (
    <Box role="alert" width="100%" height="100%">
      <Typography variant="h6">Something went wrong</Typography>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        onClick={resetErrorBoundary}
      >
        Try again
      </Button>
    </Box>
  )
}

export default class Page extends Component {
  static propTypes = {
    prop: PropTypes,
  }

  render() {
    const { children } = this.props

    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        {children}
      </ErrorBoundary>
    )
  }
}

ErrorFallback.propTypes = {
  error: PropTypes.bool,
  resetErrorBoundary: PropTypes.func,
}

Page.propTypes = {
  children: PropTypes.node,
}
